// components/ChallengesSection.jsx
import SectionReveal from './SectionReveal';
import xndirner from '../assets/xndirner.png'
export default function ChallengesSection({ t }) {
  return (
    <section id="challenges" className="relative bg-white px-3 py-6 md:px-10">

      <div className="mx-auto max-w-7xl space-y-12">

        {/* Блок 1: Заголовок + описание */}
        <SectionReveal>
          <div className="border-l-4 border-red-400 bg-gray-50 p-6 md:p-10 grid grid-cols-1 md:grid-cols-2">
            <div>
              <h2 className="text-3xl md:text-4xl font-black text-[#0B3B6F] uppercase mb-1">
                {t.problemsTitle}
              </h2>
              <h2 className="text-2xl md:text-xl font-black text-[#0B3B6F] uppercase mb-3">
                {t.problemsMainTitle}
              </h2>
              <p className="text-base text-slate-600 leading-relaxed max-w-3xl">
                {t.problemsMainDesc}
              </p>
            </div>
            <img src={xndirner} />
          </div>
        </SectionReveal>

        {/* Блок 2: Проблемы */}
        <SectionReveal delay={150}>
          <div className="border-l-4 border-red-400 bg-gray-50 p-3 md:p-10">
            <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
              {t.problemsList.map((item, idx) => (
                <div
                  key={idx}
                  className="flex items-start gap-4 p-5 bg-white border border-gray-100 hover:border-[#0FA4E8]/30 transition-all group"
                >
                  <span className="text-2xl flex-shrink-0 mt-0.5">
                    {item.icon}
                  </span>
                  <div>
                    <h3 className="text-md font-bold text-[#0B3B6F] group-hover:text-[#0FA4E8] transition-colors mb-1">
                      {item.title}
                    </h3>
                    <p className="text-sm text-slate-500 leading-relaxed">
                      {item.desc}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </SectionReveal>

        {/* Блок 3: Видение + Миссия */}
        <div className="grid gap-8 md:grid-cols-1">

          {/* Видение */}
          <SectionReveal delay={300}>
            <div className="border-l-4 border-[#0FA4E8] bg-[#0FA4E8]/5 p-6 md:p-10 h-full">
              <h3 className="text-sm font-bold text-[#0FA4E8] uppercase tracking-wider mb-3">
                {t.problemsVisionLabel}
              </h3>
              <p className="text-lg font-bold text-[#0B3B6F] leading-relaxed mb-4">
                {t.problemsVisionHeading}
              </p>
              <p className="text-base text-slate-600 leading-relaxed">
                {t.problemsVisionText}
              </p>
              <p className="mt-4 text-sm font-bold text-[#0B3B6F]">
                {t.problemsVisionFooter}
              </p>
            </div>
          </SectionReveal>
        </div>
      </div>
    </section>
  );
}